import { Link } from 'react-router-dom';
import { footerLinks } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-background-800 text-white">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-white font-bold text-sm">
                  BS
                </div>
                <span className="font-heading text-lg font-semibold text-white">
                  Basetao Sheet
                </span>
              </Link>
              <p className="text-sm text-background-300 leading-relaxed mb-4">
                Independent Basetao Spreadsheet Research &amp; Shopping Guide Platform. We are not affiliated with or endorsed by Basetao.
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-700 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-twitter-x-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-700 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-reddit-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-700 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-discord-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-white text-sm mb-4">Resources</h4>
              <ul className="space-y-2.5">
                {footerLinks.resources.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-300 hover:text-white transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-white text-sm mb-4">Categories</h4>
              <ul className="space-y-2.5">
                {footerLinks.categories.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-300 hover:text-white transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-white text-sm mb-4">Company</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/#about"
                    className="text-sm text-background-300 hover:text-white transition-colors cursor-pointer"
                  >
                    About This Site
                  </Link>
                </li>
                <li>
                  <Link
                    to="/article/basetao-review"
                    className="text-sm text-background-300 hover:text-white transition-colors cursor-pointer"
                  >
                    Disclaimer
                  </Link>
                </li>
                <li>
                  <Link
                    to="/article/basetao-legit"
                    className="text-sm text-background-300 hover:text-white transition-colors cursor-pointer"
                  >
                    Safety &amp; Privacy
                  </Link>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300 hover:text-white transition-colors cursor-pointer"
                  >
                    Main Website
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-700">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-400">
                &copy; 2026 Basetao Sheet. This is an independent educational resource. We are not the official Basetao website. All product links redirect to our partner platform.
              </p>
              <p className="text-xs text-background-500 whitespace-nowrap">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-background-300 transition-colors cursor-pointer">
                  kaspreadsheet.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}